<template>
  <h2
    class="font-bold lg:text-3xl text-EXPONDO-black"
    :class="[headerClass, isSmall ? 'text-xs' : 'text-xl']"
  >
    {{ title }}
  </h2>
</template>
<script lang="ts">

export default defineComponent({
  name: 'ProductAnchorTitle',
  props: {
    title: {
      type: String,
      default: '',
    },
    headerClass: {
      type: String,
      default: 'text-EXPONDO-black',
    },
    isSmall: {
      type: Boolean,
      default: false,
    },
  },
});

</script>
